export default "__VITE_ASSET__DpX5pua3__"